<div class="workspace-outer-container">
  <div class="workspace-inner-container">
    <reports-grid [hidden]="!showGrid" [workspace]="this"></reports-grid>
    <reports-form [oid]="oid" *ngIf="!showGrid && oid !== null"
                  [workspace]="this"
                  [parent]="parent"
                  [showPrevBtn]="previousButtonEnabled"
                  [showNextBtn]="nextButtonEnabled"
                  (showPrevious)="showPrevious()"
                  (showNext)="showNext()">
    </reports-form>
  </div>
</div>
<ng-container *ngIf="grid">
  <report-argus-sync-dialog *ngIf="showArgusSyncDialog"
                            [canClose]="true"
                            [reportIds]="selectedReports"
                            (closePane)="closeAllPanes()">
  </report-argus-sync-dialog>
</ng-container>
